// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfiguration.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfiguration component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var actions = require('./Izenda.ReportConfigurationAction');
  var ReportConfigurationHeader = require('./Izenda.ReportConfigurationHeader');
  var ReportConfigurationContent = require('./Izenda.ReportConfigurationContent');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var ReportConfiguration = React.createClass({
    componentDidMount: function () {
      var loader = this.props.loader;
      loader.startLoading();
      this.props.store.initData().finally(loader.endLoading.bind(loader));
    },

    render: function () {
      return (
        <div className="izenda-ReportConfiguration u_fullHeight u-posRelative">
          <ReportConfigurationHeader {...this.props} />
          <div className='u_fullHeight'>
            <ScrollBox>
              <ReportConfigurationContent {...this.props} />
            </ScrollBox>
          </div>
        </div>
      );
    }
  });

  module.exports = connect(actions)(ReportConfiguration);
}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.ReportConfiguration.jsx